/**
 * mk-tag-svc
 * 营销中心-标签
 *
 * OpenAPI spec version: last
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import ajax, { AjaxPromise, ExtraFetchParams } from '@ajax';
import * as models from '../model/models';

/* tslint:disable:no-unused-variable member-ordering object-literal-shorthand */

/**
  * @property `id` 
  */
export interface Paramsv1TagCusRuleGet {
  // queryParams
  id: string;
  companyId: string;
}
/**
  * @property `id` 
  */
export interface Paramsv1TagRuleGet {
  // queryParams
  id: string;
}
/**
  */
export type ParamsBodyv1TagRulePost = models.V1TagRuleBody1;
/**
  */
export type ParamsBodyv1TagRulePut = models.V1TagRuleBody;
/**
  * @description v1TagRuleTriggerListGet参数
  * @property `name` 配置名eg:template_config or crm_config or tag_rule_config
  * @property `[industry]` 行业 estate-地产  common-普通
  * @property `[materialType]` 规则类型(article/brochure/form/H5/link/video-markting)
  * @property `[industry2]` 行业 estate-地产 common-普通
  * @property `[name2]` 配置名
  */
export interface Paramsv1TagRuleTriggerListGet {
  // queryParams
  /**
   * 配置名eg:template_config or crm_config or tag_rule_config
   */
  name: string;
  /**
   * 行业 estate-地产  common-普通
   */
  industry?: string;
  /**
   * 规则类型(article/brochure/form/H5/link/video-markting)
   */
  materialType?: string;
  /**
   * 行业 estate-地产 common-普通
   */
  industry2?: string;
  /**
   * 配置名
   */
  name2?: string;
}

export class RuleApi {
  protected $basePath = '/biz'.replace(/\/$/, '');

  public constructor(basePath?: string) {
    if (basePath !== undefined) {
      this.$basePath = basePath.replace(/\/$/, '');
    }
  }

  /**
   * 
   * @summary C端获取行为标签规则详情
   * @param params Paramsv1TagCusRuleGet
   
   * @param opt ajax config
   * @returns models.V1TagCusRule
   */
  public v1TagCusRuleGet = (
    params: Paramsv1TagCusRuleGet,
    opt?: ExtraFetchParams
  ) : AjaxPromise<models.V1TagCusRule>  => {
    const path = '/v1/tag/cus_rule';
    const url = this.$basePath + path;
    const p: any = {};
    p.query = {};
    if ('id' in params) p.query.id = params.id;
    if ('id' in params) p.query.companyId = params.companyId;
    ajax.check(params.id, 'id');
    ajax.check(params.companyId, 'companyId');
    return ajax.ajax({
      ...opt,
      method: 'GET',
      url,
      ...p
    });
  }
  /**
   * 
   * @summary 获取行为标签规则详情
   * @param params Paramsv1TagRuleGet
   
   * @param opt ajax config
   * @returns models.V1TagRule
   */
  public v1TagRuleGet = (
    params: Paramsv1TagRuleGet,
    opt?: ExtraFetchParams
  ) : AjaxPromise<models.V1TagRule>  => {
    const path = '/v1/tag/rule';
    const url = this.$basePath + path;
    const p: any = {};
    p.query = {};
    if ('id' in params) p.query.id = params.id;
    ajax.check(params.id, 'id');
    return ajax.ajax({
      ...opt,
      method: 'GET',
      url,
      ...p
    });
  }
  /**
   * 
   * @summary 创建-修改行为标签规则
   
   * @param data: ParamsBodyv1TagRulePost
   * @param opt ajax config
   * @returns models.InternalRule
   */
  public v1TagRulePost = (
    
    data: ParamsBodyv1TagRulePost,opt?: ExtraFetchParams
  ) : AjaxPromise<models.InternalRule>  => {
    const path = '/v1/tag/rule';
    const url = this.$basePath + path;
    const p: any = {};
    p.data = data;
    return ajax.ajax({
      ...opt,
      method: 'POST',
      url,
      ...p
    });
  }
  /**
   * 
   * @summary 批量修改行为标签规则
   
   * @param data: ParamsBodyv1TagRulePut
   * @param opt ajax config
   * @returns models.V1TagRule1
   */
  public v1TagRulePut = (
    
    data: ParamsBodyv1TagRulePut,opt?: ExtraFetchParams
  ) : AjaxPromise<models.V1TagRule1>  => {
    const path = '/v1/tag/rule';
    const url = this.$basePath + path;
    const p: any = {};
    p.data = data;
    return ajax.ajax({
      ...opt,
      method: 'PUT',
      url,
      ...p
    });
  }
  /**
   * 
   * @summary 获取行为规则列表
   * @param params Paramsv1TagRuleTriggerListGet
   
   * @param opt ajax config
   * @returns models.V1TagRuleTriggerList
   */
  public v1TagRuleTriggerListGet = (
    params: Paramsv1TagRuleTriggerListGet,
    opt?: ExtraFetchParams
  ) : AjaxPromise<models.V1TagRuleTriggerList>  => {
    const path = '/v1/tag/rule/triggerList';
    const url = this.$basePath + path;
    const p: any = {};
    p.query = {};
    if ('name' in params) p.query.name = params.name;
    ajax.check(params.name, 'name');
    if ('industry' in params) p.query.industry = params.industry;
    if ('materialType' in params) p.query.materialType = params.materialType;
    if ('industry2' in params) p.query.industry2 = params.industry2;
    if ('name2' in params) p.query.name2 = params.name2;
    return ajax.ajax({
      ...opt,
      method: 'GET',
      url,
      ...p
    });
  }
}

export default new RuleApi();